import { render, staticRenderFns } from "./publicAccountUser.vue?vue&type=template&id=01525cae"
import script from "./publicAccountUser.vue?vue&type=script&lang=js"
export * from "./publicAccountUser.vue?vue&type=script&lang=js"
import style0 from "./publicAccountUser.vue?vue&type=style&index=0&id=01525cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports